export default __webpack_public_path__ + "static/Horizontal-Single-Program-YEL-WHT-ff407f82956ce9e3dfa5175ce7362796.png";